function generateAction(type, ...props) {
  if (!props.length) {
    throw 'ActionTypeMissing';
  }

  return (...args) => {
    const action = {
      type: props[0],
    };

    for (const name of props) {
      if (name === action.type) {
        continue;
      }
      action[name] = args.shift();
    }

    return action;
  };
}

export default {
  types(map) {
    const result = {};

    for (const type of map) {
      result[type] = type;
    }

    return result;
  },

  generate(map) {
    const types = Object.keys(map);

    for (const type of types) {
      map[type] =
        typeof map[type] === 'function'
          ? map[type]
          : generateAction(type, ...map[type]);
    }

    return map;
  },
};
